import * as React from "react";
import { Form, Select, DropdownItemProps } from "semantic-ui-react";
import { DropdownOption } from "../../utils/pdApiUtils";

export type DropdownFieldProps = {
  id: string;
  label?: string;
  placeholder?: string;
  value: number | string | null;
  isError?: boolean;
  errorMessage?: string;
  options: DropdownOption[];
  disabled?: boolean;
  search?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void;
  text?: string;
};

function DropdownField({
  label,
  value,
  isError=false,
  errorMessage = "",
  placeholder,
  options,
  disabled = false,
  search = false,
  onChange,
  id
}: DropdownFieldProps): JSX.Element {
  return (
    <div className="uidropdown">
      <Form.Field
        id={id}
        control={Select}
        label={label}
        error={isError}
        placeholder={placeholder}
        options={options}
        value={value}
        disabled={disabled}
        search={search}
        // eslint-disable-next-line
        onChange={({}, data: DropdownItemProps) => {
          onChange(data.value);
        }}        
      />
      {(isError && errorMessage) && <p className="errMsgMargindropdown">{errorMessage}</p>}
    </div>
  );
}

export default DropdownField;
